<template>
  <div style="display:inline-block;vertical-align: top" :class="tags?'tags':'checkbox'" :style="'width:' + width">
    <input type="checkbox" :id="randomId" :value="label" v-model="model" @change="change">
    <label :for="randomId" ><slot></slot></label>
  </div>
</template>

<script>
  export default {
    name: "VCheckbox",
    props:{
      width:{
        default:''
      },
      label:{
        type:[String,Number,Boolean,Object]
      },
      value: {
        type:[String,Number,Boolean,Array],
      },
      tags:{
        type:Boolean,
        default:false
      }
    },
    data () {
      return {
        randomId:'checkbox-' + Math.random(),
        model:this.value
      }
    },
    watch:{
      value:function (val) {
        this.model = val
      },
      model:function (val) {
        this.$emit('input',val)
      }
    },
    methods:{
      change(){
        this.$emit('change')
      }
    }
  }
</script>

<style lang="less" scoped>
  @import '@/assets/css/varible.less';
  label{
    display: inline-block;
    margin-bottom: 7px;
    margin-right: 10px;
  }

  .tags>label {
    width: auto;
    transition: all 0.3s;
    margin-right: 7px;
    background: #eee;
    color:#333;
    padding:3px;
    font-size: small;
    text-align: center;
    border-radius: 3px
  }
  .tags>input[type="checkbox"] {
      display: none;
  }

  .tags>input[type="checkbox"]:checked + label{
      background: #4094d1;
      color:#fff;
  }

</style>
